import { useSelector } from 'react-redux';
import { sendAnalyticsEvents } from '../../analytics';
import { selectEventsData } from '../store/events';
import { parseOnboardingPath } from '../../locales/languageConfig';

export const useSendEvents = ({ screenId = '' }: { screenId?: string } = {}) => {
  const eventsData = useSelector(selectEventsData);

  return (eventName: string, eventParams: { [key: string]: any } = {}) => {
    const pathName = {
      screen_name: (
        eventParams?.screen_name ||
        screenId ||
        parseOnboardingPath(window.location.pathname).cleanPath
      ).replace('/', ''),
    };
    const extendedEventsData = { ...eventsData, ...eventParams, ...pathName };
    sendAnalyticsEvents(eventName, extendedEventsData);
  };
};
